import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import cameraIcon from "../../Images/camera.svg";
import SVGButton from "../Buttons/SVGButton";
import deleteIcon from "../../Images/Delete.svg";
import editIcon from "../../Images/edit.svg";
import Modal from "../Kanban/Modal/Modal";
import { useFormikContext } from "formik";
import FormikInput from "../Formik/FormikInput";
import { onChangeProductMediaURL } from "../../DataApi/products/onChangeProductMediaURL";
import { useSession } from "../../authentications/SessionContext";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { primaryColor } from "../../utilities/colors";

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : "#ff5837"};
  color: ${(props) => (props["data-isvtex"] ? primaryColor.primary : "#fff")};
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 90px;
  height: 35px;
  margin-right: 20px;
`;
function NewProductMedia({
  disabled,
  isModalOpen,
  setIsModalOpen,
  media,
  setMedia,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { setFieldValue, values, setFieldError, errors } = useFormikContext();
  const imageInputRef = useRef();
  const [selectedMedia, setSelectedMedia] = useState(null);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleResetValues = () => {
    setFieldValue("temp", {
      name: values.name,
      video_url: "",
      embed_code: "",
      sequence: "",
    });
    setSelectedMedia(null);
  };
  const closeModal = () => {
    handleResetValues();

    setMedia("");
    setIsModalOpen(false);
  };

  const handleSelectMedia = (e) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => {
        setFieldValue("temp.image_1920", base64);
        setSelectedMedia(base64);
      });
    }
  };
  const handleEditMedia = () => {
    imageInputRef.current.click();
  };

  const handleDeleteMedia = () => {
    setSelectedMedia(null);
  };
  const getActionID = (id) => {
    if (id) {
      if (`${id}`?.includes("virtual")) {
        return { actionId: 0, sliceCount: 1 };
      }
      return { actionId: 1, sliceCount: 1 };
    }

    return { actionId: 0, sliceCount: 0 };
  };
  const handleSaveMedia = () => {
    let selectedMediaIndex = values?.product_template_image_ids?.length || 0;
    if (media) {
      selectedMediaIndex = values.product_template_image_ids?.findIndex(
        (item) => item[1] === media.id
      );
    }
    const {
      name,
      video_url = false,
      image_1920 = false,
      id = false,
      sequence = 10,
    } = values.temp;

    if (video_url || image_1920) {
      const mediaList = values.product_template_image_ids
        ? [...values.product_template_image_ids]
        : [];
      const newPayload = {
        sequence,
        name,
        video_url,
        image_1920,
        __last_update: false,
      };
      if (id === false || id === "") {
        newPayload.id = `virtual_${parseInt(Math.random() * 1000)}`;
      } else {
        newPayload.id = id;
      }

      const { actionId, sliceCount } = getActionID(id);
      mediaList.splice(selectedMediaIndex, sliceCount, [
        actionId,
        newPayload.id,
        newPayload,
      ]);

      setFieldValue("product_template_image_ids", [...mediaList]);
    }
  };
  const isValidData = () => {
    if (!values.temp.name) {
      setFieldError("temp.name", "Name is Required");
      return false;
    }
    if (!values.temp.image_1920) {
      setFieldError("temp.image_1920", "Image is Required");
      return false;
    }
    return true;
  };
  const handleSaveAndClose = () => {
    if (isValidData()) {
      handleSaveMedia();
      closeModal();
    }
  };
  const handleSaveAndNew = () => {
    if (isValidData()) {
      handleSaveMedia();
      handleResetValues();
      setMedia("");
    }
  };
  const onChangeVideoURL = (e) => {
    const temp = { ...values.temp, video_url: e.target.value || "" };
    fetchMediaData({ ...values, temp }).then((resp) => {
      setFieldValue("temp", {
        ...temp,
        embed_code: resp?.result?.value?.embed_code || "",
      });
    });
  };
  const fetchMediaData = async (newValues = values) => {
    let response = await onChangeProductMediaURL({
      company_id,
      context,
      product: newValues || values || {},
    });
    return response;
  };
  useEffect(() => {
    if (isModalOpen) {
      setSelectedMedia(media.image_1920 || "");
      if (media) {
        fetchMediaData({ ...values, temp: media }).then((resp) => {
          setFieldValue("temp", {
            name: media.name || values.name || "",
            image_1920: media.image_1920 || "",
            video_url: media.video_url || "",
            embed_code:
              resp?.result?.value?.embed_code || media.embed_code || "",
            sequence: media.sequence || "",
            id: media.id || "",
          });
        });
        return;
      }
      setFieldValue("temp", {
        name: values.name || "",
        video_url: "",
        embed_code: "",
        sequence: "",
      });
    }
  }, [isModalOpen, media]);

  return (
    <div>
      <div className="extra_product_text">{t["Extra Product Media"]}</div>

      <button
        type="button"
        disabled={disabled}
        onClick={openModal}
        style={{
          color: primaryColor.primary,
          border: "none",
          marginTop: "10px",
          backgroundColor: "transparent",
          fontWeight: "500",
        }}
      >
        + {t["Add a Media"]}
      </button>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="modal-header">
          <h5 className="modal-title">{t["Create Extra Product Media"]}</h5>
          <button
            type="button"
            className="ms-2 btn-close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body">
          <div className="d-flex gap-4">
            <div className="w-100">
              <div className="mb-3">
                <label className="form-label">{t["Product Image Name"]}</label>
                <FormikInput name="temp.name" />
              </div>
              <div className="mb-3">
                <label className="form-label">{t["Video URL"]}</label>
                <FormikInput
                  onChange={onChangeVideoURL}
                  name="temp.video_url"
                  id="video_url"
                />
              </div>
              <div
                className="mt-4"
                dangerouslySetInnerHTML={{
                  __html: values?.temp?.embed_code || "",
                }}
              />
            </div>
            <div className="w-50 position-relative">
              <div
                className="media_image_container position-relative"
                style={{
                  width: 200,
                  height: 200,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                {selectedMedia ? (
                  <>
                    <UploadedImage src={selectedMedia || ""} />
                    <div className="edit-delete-icons position-absolute top-0 start-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={"editIcon"}
                        onClick={handleEditMedia}
                      />
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={"deleteIcon"}
                        onClick={handleDeleteMedia}
                      />
                    </div>
                  </>
                ) : (
                  <div className="media_upload_container">
                    <img
                      src={cameraIcon}
                      alt="Upload Icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onClick={handleEditMedia}
                    />
                  </div>
                )}
                <input
                  ref={imageInputRef}
                  type="file"
                  accept="image/*"
                  id="fileInput"
                  onChange={handleSelectMedia}
                  hidden
                />
              </div>
              {errors?.temp?.image_1920?.length > 0 && (
                <div className="ps-2 error-message">
                  {errors.temp.image_1920}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-center">
          <ActionButton
            data-isvtex={isVTEX}
            type="button"
            onClick={handleSaveAndClose}
          >
            {t["Save & Close"]}
          </ActionButton>
          <ActionButton
            data-isvtex={isVTEX}
            type="button"
            onClick={handleSaveAndNew}
          >
            {t["Save & New"]}
          </ActionButton>
          <ActionButton data-isvtex={isVTEX} type="button" onClick={closeModal}>
            {t["Discard"]}
          </ActionButton>
        </div>
      </Modal>
    </div>
  );
}

export default NewProductMedia;
